export const typeRetirement = {
    'domicilio': 'Envío a Domicilio',
    'farmacia': 'Retiro en Farmacia'}